import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';

import styles from './OtpCode.module.scss';
import OtpInput from './OtpInput';

const CODE_LENGTH = 6;

type OtpCodeProps = {
  onSubmit?: (code: string) => void;
  isLoading?: boolean;
  error?: string;
  submitLabel?: string;
  onChange?: () => void;
};

const OtpCode = ({
  onSubmit,
  isLoading,
  error,
  submitLabel = 'Continue',
  onChange,
}: OtpCodeProps) => {
  const { t } = useTranslation();
  const [values, setValues] = useState<string[]>(Array(CODE_LENGTH).fill(''));

  const code = values.join('');

  const handleSubmit = () => {
    if (code.length === CODE_LENGTH && values.every(Boolean)) {
      onSubmit?.(code);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.headingContainer}>
        <h1>{t('authPage.otp.heading')}</h1>
        <p>{t('authPage.otp.text')}</p>
      </div>

      <OtpInput value={values} onChange={setValues} onUserInput={onChange} />

      <p className={styles.error}>{error ? error : null}</p>

      <Button className={styles.verify} type="button" onClick={handleSubmit} disabled={isLoading}>
        {isLoading ? t('common.loading', { defaultValue: 'Loading…' }) : submitLabel}
      </Button>
    </div>
  );
};

export default OtpCode;
